export const DETAIL_KEYS = {
  'Dimensions and Weight': 'dimensionAndWeight',
  'Engine and Transmission': 'engineAndTransmission',
  Capacity: 'capacity',
  'Suspension, Brakes, Steering and Tyres': 'suspension',
  Safety: 'safety',
  'Braking and Traction': 'brakingAndTraction',
  'Lock and Security': 'lockAndSecurity',
  'Comfort and Convenience': 'comfortAndConvenience',
  Telematics: 'telematics',
  Exterior: 'exterior',
  Lighting: 'lighting',
  'Doors Windows Mirrors and Wipeers': 'doorsAndWindows',
  'Entertainment Information and Communication': 'entertainmentAndComm',
  'On road price by city': 'onRoadPrice',
};

export const CONTACT_TYPE = {
  phoneCall: 'PHONE_CALL',
  whatsapp: 'WHATSAPP',
};

export const WHATSAPP_TEMPLATE =
  'Hi, I would like to enquire about the <car-slug>,<kms-driven> Km driven, <deeplink> which you have listed for <price> on the Park+ platform.';

export const BANNER_IMAGES = [
  '/app/img/ucd/card-1.png',
  '/app/img/ucd/card-2.png',
  '/app/img/ucd/card-3.png',
];

export enum ModifyFavourites {
  remove = 'REMOVE_FROM_FAVOURITES',
  add = 'ADD_TO_FAVOURITES',
}

export const FILTER_INIT = {
  price: {
    min: null,
    max: null,
    isSelected: false,
  },
  make: {
    brand: null,
    model: null,
    isSelected: false,
  },
  distance: {
    min: null,
    max: null,
    isSelected: false,
  },
  kmDriven: {
    value: null,
    isSelected: false,
  },
  fuelType: {
    value: null,
    isSelected: false,
  },
  bodyType: {
    value: null,
    isSelected: false,
  },
  transmission: {
    value: null,
    isSelected: false,
  },
  ownerCount: {
    value: null,
    isSelected: false,
  },
};

export enum DisplayCodes {
  successNoData = 'SUCCESS_NO_DATA',
  successWithData = 'SUCCESS_WITH_DATA',
  failure = 'FAILURE',
  loading = 'LOADING',
  noVariantId = 'NO_VARIANT_ID',
}

export enum UserInputs {
  IMMEDIATELY = 'IMMEDIATELY',
  ONE_MONTH = 'ONE_MONTH',
  TWO_THREE_MONTH = 'TWO_THREE_MONTH',
  JUST_EXPLORING = 'JUST_EXPLORING',
}

// User Lead Feedback
export enum DEALER_LEAD_RESPONSE {
  YES = 'YES',
  NO = 'NO',
}

export enum LEAD_PRIMARY_RESPONSE {
  VISIT_SCHEDULED = 'VISIT_SCHEDULED',
  UNDER_DISCUSSION = 'UNDER_DISCUSSION',
  NO_DEAL = 'NO_DEAL',
}

export enum LEAD_SECONDARY_RESPONSE {
  ALREADY_SOLD = 'ALREADY_SOLD',
  PRICE_DIFF = 'PRICE_DIFF',
  EXPLORING = 'EXPLORING',
}
